import {Record} from 'immutable';

export const PERMISSION_TYPES = [
  {label: 'Edit', value: 'EDIT'},
  {label: 'Share', value: 'SHARE'},
  {label: 'Notify', value: 'NOTIFY'},
];

const targetProps = ['accountId', 'departmentId', 'teamId', 'userId'];

export default class TriggerPermission extends Record({
  id: undefined,
  active: true,
  // FE property only, tracks whether a permission is deleted
  // (compare with active = false, see RulePermissionsDialog.filterForSave for more details)
  deleted: false,
  permission: 'NOTIFY',
  groupName: null,
  // FE property only, tracks when a new one is created, for sorting
  uiCreationTime: null,
  ...targetProps.reduce((props, prop) => ({...props, [prop]: null}), {}),
}) {
  isSameTarget(permission) {
    return targetProps.every(prop => this[prop] === permission[prop]);
  }
  getSortIndex() {
    return targetProps.findIndex(prop => this[prop]);
  }
}
